import { StyleProp, ViewStyle } from "react-native";
import useStyle from "src/hooks/useStyle";
import IconTrash from "src/icons/IconTrash";
import { color } from "src/styles";
import FloatingActionItem from "./FloatingActionItem";

const FloatingDeleteButton = ({
	containerStyle,
	onPress,
	loading,
}: {
	containerStyle?: StyleProp<ViewStyle>;
	onPress?: () => void;
	loading?: boolean;
}) => {
	const { theme } = useStyle();
	return (
		<FloatingActionItem
			loading={loading}
			Icon={IconTrash}
			onPress={onPress}
			containerStyle={containerStyle}
			color={color.Destructive[theme]}
			testID="Select-Delete"
		/>
	);
};
export default FloatingDeleteButton;
